/**
 * Did this event start on a control the row does not own?
 *
 * Clickable table rows carry their own per-cell links and buttons — a submission
 * badge that opens in a new tab, an office link, a re-rate button. Those already
 * `stopPropagation` on click, but NOT on `auxclick`, so without this guard a
 * middle-click on the submission badge opens two tabs: the badge's own anchor and
 * the row's.
 *
 * `closest` walks up from the target, so it catches a click on anything inside the
 * control (the text in a badge, the icon in a button) and not just the control
 * itself.
 */
export function isNestedInteractive(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return target.closest("a, button, input, select, textarea, [role='button']") !== null;
}
